/** @format */

import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useInvoicesList(proxy) {
  // Use toast
  const toast = useToast()

  const orderListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    {
      key: 'actions',
      label: '操作',
      thStyle: {
        width: '100px',
      },
    },
    { key: 'id', label: '会员名称' },
    {
      key: 'number',
      label: '保单号',
    },
    {
      key: 'product.title',
      label: '公司',
    },
    {
      label: '分担人数',
      key: 'share_number',
    },
    {
      key: 'protect_user',
      label: '被保人',
      formatter: value => (!value ? '-- 无 --' : `${value}`),
    },

    {
      label: '佣金类型',
      // key: 'commission_type',
      key: 'count_cate',
      formatter: value => (!value ? '-- 无 --' : `${value}`),
    },
    // {
    //   label: '应收佣金',
    //   key: 'commission_amount',
    //   formatter: value => (!value ? '-- 无 --' : `${value}`),
    // },
    // {
    //   label: '实收佣金',
    //   key: 'paid_commission_amount',
    //   formatter: value => (!value ? '-- 无 --' : `${value}`),
    // },

    {
      key: 'user_income',
      label: '佣金收入',
    },

    {
      key: 'submit_at',
      label: '提交时间',
    },
    // {
    //   key: 'created_at',
    //   label: '提交时间',
    // },
    // {
    //   key: 'apply_time',
    //   label: '生效日期',
    // },
    {
      key: 'desc',
      label: '备注',
      formatter: value => (!value ? '-- 无 --' : `${value}`),
    },
  ]
  const perPage = ref(100) // pageSize
  const totalInvoices = ref(0) // total
  const currentPage = ref(1) // now Page
  const perPageOptions = [10, 25, 50, 100] // pageSize Array
  const searchQuery = ref('') // searchQuery
  const protect_user = ref('')
  const member = ref('')
  const order_number = ref('')
  const user_id = ref('')
  const id = ref('')

  const dataMeta = computed(() => {
    const localItemsCount = orderListTable.value ? orderListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalInvoices.value,
    }
  })

  const refetchData = () => {
    orderListTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery, user_id, id, order_number, member, protect_user], () => {
    refetchData()
  })

  const fetchInvoices = (ctx, callback) => {
    console.log(protect_user)
    store
      .dispatch('user-order/fetchListData', {
        pageSize: perPage.value,
        page: currentPage.value,
        user_id: user_id.value,
        number: searchQuery.value,
        id: id.value,
        protect_user: protect_user.value,
        type: 'vmember',
        member: member.value,
        order_number: order_number.value,
      })
      .then(response => {
        const { list, total } = response.data
        callback(list)
        totalInvoices.value = total
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: "Error fetching invoices' list",
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  // 删除
  const deleteInvoice = val => {
    store
      .dispatch('user-order/orderDelete', val)
      .then(response => {
        if (response.code == 0) {
          toast({
            component: ToastificationContent,
            props: {
              title: response.msg,
              icon: 'CheckCircleIcon',
              variant: 'success',
            },
          })
          refetchData()
        } else {
          toast({
            component: ToastificationContent,
            props: {
              title: response.msg,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        }
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: '删除错误!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }
  // 审核
  const auditInvoice = val => {
    store
      .dispatch('user-order/orderAudit', val)
      .then(response => {
        if (response.code == 0) {
          toast({
            component: ToastificationContent,
            props: {
              title: response.msg,
              icon: 'CheckCircleIcon',
              variant: 'success',
            },
          })
          proxy.$bvModal.hide('audit-modal')
          refetchData()
        } else {
          toast({
            component: ToastificationContent,
            props: {
              title: response.msg,
              icon: 'CheckCircleIcon',
              variant: 'danger',
            },
          })
        }
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: '审核错误!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }
  // 订单详情

  return {
    user_id,
    fetchInvoices,
    tableColumns,
    perPage,
    currentPage,
    totalInvoices,
    dataMeta,
    perPageOptions,
    searchQuery,
    id,
    protect_user,
    orderListTable,
    deleteInvoice,
    auditInvoice,
    refetchData,
    member,
    order_number,
  }
}
